/**
 * @desc 根据工号获取详情
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(jobNo: string | number, options?: any) {
  return updateResponse(
    http(URL + `/organizationStaff/getStaffInfoByJobNo/${jobNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
